import React, { useLayoutEffect } from 'react';
import { connect } from "react-redux";
import { NEW_VIEW_PATH, VIEW_PATH } from "../../../../config/paths";
import PropTypes from "prop-types";
import { breadcrumbsPropTypes } from "../../../common/resource/proptypes/CommonPropTypes";
import Immutable from "immutable";
import { DEFAULT_PAGE_SIZE } from "../../../../config/constants";
import { VIEWS_COLUMNS } from "../../../../config/columns";
import ModuleList from "../../../layout/ModuleList";
import { clearViews, getViews } from '../../../../actions/security/View';


const Views = ({
  breadcrumbs,
  views,
  loading,
  dispatchGetViews,
  dispatchClearViews,
}) => {
    useLayoutEffect(() => () => dispatchClearViews(), []);

    const data = views.get('content') || [];
    const pages = views.get('totalPages') || null;
    const defaultPageSize = views.get('size') || DEFAULT_PAGE_SIZE;

    return (
      <ModuleList
        title="Lista de Vistas"
        breadcrumbs={breadcrumbs}
        buttonPath={NEW_VIEW_PATH}
        tableStructure={{
          columns: VIEWS_COLUMNS,
          data,
          pages,
          defaultPageSize,
          filterable: true,
          fetchData: dispatchGetViews,
          modelPath: VIEW_PATH,
          loading,
          navigateToModelOnRowClick: true,
        }}
      />
    );
};

Views.propTypes = {
  breadcrumbs: breadcrumbsPropTypes.isRequired,
  dispatchClearViews: PropTypes.func.isRequired,
  dispatchGetViews: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  views: PropTypes.instanceOf(Immutable.Map),
};

Views.defaultProps = {
  loading: false,
};

const mapDispatchToProps = {
  dispatchClearViews: clearViews,
  dispatchGetViews: getViews,
};

const mapStateToProps = ({ SecurityUnit }) => ({
  breadcrumbs: [
    ...SecurityUnit.UnitHome.get('breadcrumbs'),
    {
      text: 'Lista de Vistas',
      href: VIEW_PATH,
    },
    {
      text: 'Ver',
      href: '',
    },
  ],
  views: SecurityUnit.View.getIn(['all', 'content']),
  loading: SecurityUnit.View.getIn(['all', 'loading']),
});

Views.defaultProps = {
  views: null,
  loading: false,
};

export default connect(mapStateToProps, mapDispatchToProps)(Views);